(async function init() {

  const GIFT_VARIANT_ID = 45691129430189;
  const MIN_CART_TOTAL_USD = 500;
  const REQUIRED_VENDOR = "Briggs & Riley";
  const POPUP_DISMISSED_AT_KEY = 'free_gift_popup_dismissed_at';

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function getUSDRate(currency) {
    try {
      const res = await fetch(`https://open.er-api.com/v6/latest/USD`);
      const data = await res.json();
      const rate = data.rates[currency.toUpperCase()];
      return rate || null;
    } catch (e) {
      return null;
    }
  }

  async function fetchVariantInfo(variantId) {
    try {
      const res = await fetch(`/variants/${variantId}.js`);
      if (res.ok) {
        const variant = await res.json();
        const image = variant.featured_image?.src || '';
        // const price = `$${parseFloat(variant.price).toFixed(2)}`;
        const title = variant.name || variant.title || 'Free Gift';
        return { title, image };
      }
    } catch (e) {}
    return { title: 'Free Gift', image: '', price: '' };
  }

  async function addGift() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1,
        properties: { _free_gift: 'true' }
      })
    });
    location.reload();
  }

  function wasDismissedForThisTotal(currentTotalUSD) {
    const dismissedAt = parseFloat(sessionStorage.getItem(POPUP_DISMISSED_AT_KEY));
    if (isNaN(dismissedAt)) return false;
    return currentTotalUSD < dismissedAt + 50;
  }

  function dismissPopup(popup, currentTotalUSD) {
    sessionStorage.setItem(POPUP_DISMISSED_AT_KEY, currentTotalUSD.toFixed(2));
    if (popup) popup.remove();
  }

  async function showGiftPopup(currentTotalUSD) {
    if (wasDismissedForThisTotal(currentTotalUSD)) return;
    if (document.querySelector('#free-gift-popup')) return;

    const { title, image, price } = await fetchVariantInfo(GIFT_VARIANT_ID);

    const popup = document.createElement("div");
    popup.id = "free-gift-popup";
    popup.innerHTML = `
      <div class="fg-overlay"></div>
      <div class="fg-modal">
        <button class="fg-close">&times;</button>
        <h2>Your Free Gift is Waiting!</h2>
        <p class="fg-subtitle">
          Eligible with your order - click below to add it to your cart.
        </p>
        <div class="fg-products">
          <div class="fg-product active">
            ${image ? `<img src="${image}" alt="${title}">` : ''}
            <h4>${title}</h4>
            ${price ? `<p>${price}</p>` : ''}
          </div>
        </div>
        <div class="fg-buttons">
          <button class="fg-add">ADD FREE GIFT</button>
          <button class="fg-no">NO, THANKS</button>
        </div>
      </div>
    `;

    document.body.appendChild(popup);

    popup.querySelector(".fg-add").onclick = async () => {
      const btn = popup.querySelector(".fg-add");
      btn.textContent = "Adding...";
      btn.disabled = true;
      await addGift();
    };

    popup.querySelector(".fg-no").onclick = () => dismissPopup(popup, currentTotalUSD);
    popup.querySelector(".fg-close").onclick = () => dismissPopup(popup, currentTotalUSD);
    popup.querySelector(".fg-overlay").onclick = () => dismissPopup(popup, currentTotalUSD);
  }

  async function checkCart() {
    const cart = await getCart();

    const currency = cart.currency; // Shopify provides this e.g. "PHP", "USD"

    const giftItem = cart.items.find(i => i.variant_id == GIFT_VARIANT_ID);
    const briggsItems = cart.items.filter(
      i => i.vendor === REQUIRED_VENDOR && i.variant_id != GIFT_VARIANT_ID
    );

    if (briggsItems.length === 0) {
      sessionStorage.removeItem(POPUP_DISMISSED_AT_KEY);
      return;
    }

    // Total in local currency (cents), convert to major units
    const briggsLocalTotal = briggsItems.reduce((sum, item) => {
      return sum + (item.line_price / 100);
    }, 0);

    // Convert to USD
    let briggsTotalUSD = briggsLocalTotal;
    if (currency !== 'USD') {
      const rate = await getUSDRate(currency);
      if (rate) {
        briggsTotalUSD = briggsLocalTotal / rate;
      } else {
        console.warn('Could not fetch exchange rate, skipping popup.');
        return;
      }
    }

    console.log(`Cart currency: ${currency} | Local total: ${briggsLocalTotal} | USD total: ${briggsTotalUSD.toFixed(2)}`);
    console.log('Qualifies ($500 USD):', briggsTotalUSD >= MIN_CART_TOTAL_USD);

    const qualifies = briggsTotalUSD >= MIN_CART_TOTAL_USD;

    if (qualifies && !giftItem) {
      await showGiftPopup(briggsTotalUSD);
    } else if (!qualifies) {
      const popup = document.querySelector('#free-gift-popup');
      if (popup) popup.remove();
      sessionStorage.removeItem(POPUP_DISMISSED_AT_KEY);
    }
  }

  checkCart();
  setInterval(checkCart, 1500);

})();

// Charms
document.addEventListener("DOMContentLoaded", () => {

  // ─── INJECT STYLES (matches B&R popup layout) ──────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    #bellroy-free-gift-popup {
      position: fixed; inset: 0;
      z-index: 2147483647;
      display: flex; align-items: center; justify-content: center;
    }
    #bellroy-free-gift-popup .bfg-overlay {
      position: absolute; inset: 0; background: rgba(0,0,0,0.5);
    }
    #bellroy-free-gift-popup .bfg-modal {
      position: relative; background: #fff; border-radius: 12px;
      padding: 36px 32px 28px; max-width: 480px; width: 92%;
      box-shadow: 0 8px 40px rgba(0,0,0,0.2); text-align: center;
    }
    #bellroy-free-gift-popup .bfg-close {
      position: absolute; top: 14px; right: 18px; background: none;
      border: none; font-size: 22px; cursor: pointer; color: #333; line-height: 1;
    }
    #bellroy-free-gift-popup h2 {
      margin: 0 0 10px; font-size: 24px; font-weight: 800; color: #111;
    }
    #bellroy-free-gift-popup .bfg-subtitle {
      margin: 0 0 24px; font-size: 14px; color: #666; line-height: 1.5;
    }
    #bellroy-free-gift-popup .bfg-products {
      display: flex; gap: 14px; justify-content: center; margin-bottom: 24px;
    }
    #bellroy-free-gift-popup .bfg-product {
      flex: 1; border: 1.5px solid #ddd; border-radius: 10px;
      padding: 16px 12px; display: flex; flex-direction: column;
      align-items: center; gap: 10px;
    }
    #bellroy-free-gift-popup .bfg-product img {
      width: 100%; max-width: 130px; height: 130px; object-fit: contain;
    }
    #bellroy-free-gift-popup .bfg-product .bfg-img-placeholder {
      width: 130px; height: 130px; background: #f5f5f5; border-radius: 6px;
      display: flex; align-items: center; justify-content: center; color: #bbb; font-size: 12px;
    }
    #bellroy-free-gift-popup .bfg-product h4 {
      margin: 0; font-size: 13px; font-weight: 700; color: #111; line-height: 1.4;
    }
    #bellroy-free-gift-popup .bfg-qty-badge {
      display: inline-block; background: #111; color: #fff;
      font-size: 11px; font-weight: 700; border-radius: 4px;
      padding: 2px 8px; margin-bottom: 2px; letter-spacing: 0.4px;
    }
    #bellroy-free-gift-popup .bfg-buttons {
      display: flex; gap: 10px; justify-content: center;
    }
    #bellroy-free-gift-popup .bfg-add-all {
      flex: 1; background: #111; color: #fff; border: none; border-radius: 6px;
      padding: 13px 20px; font-size: 13px; font-weight: 700; cursor: pointer;
      letter-spacing: 0.5px; transition: background 0.2s;
    }
    #bellroy-free-gift-popup .bfg-add-all:hover:not(:disabled) { background: #333; }
    #bellroy-free-gift-popup .bfg-add-all:disabled { opacity: 0.6; cursor: not-allowed; }
    #bellroy-free-gift-popup .bfg-no {
      flex: 1; background: #f0f0f0; color: #444; border: none; border-radius: 6px;
      padding: 13px 20px; font-size: 13px; font-weight: 600; cursor: pointer;
      transition: background 0.2s;
    }
    #bellroy-free-gift-popup .bfg-no:hover { background: #e0e0e0; }
  `;
  document.head.appendChild(style);
  // ───────────────────────────────────────────────────────────────────────────

  // ─── CONFIG ────────────────────────────────────────────────────────────────
  const REQUIRED_VENDOR      = "Bellroy";

  // Products that trigger the gift (combined qty determines tier)
  const TRIGGER_PRODUCT_IDS  = [45634076475565, 45634076541101];

  // The two charm gift variants (Horse + Owl)
  const GIFT_VARIANT_IDS     = [45699177021613, 45699177054381];

  // Hardcoded images — unlisted products block image access via storefront API
  const GIFT_IMAGES = {
    45699177021613: 'https://cdn.shopify.com/s/files/1/0664/2738/8077/files/BellroyNewYearCharm-Horse.jpg?v=1770167759',
    45699177054381: 'https://cdn.shopify.com/s/files/1/0664/2738/8077/files/Bellroy_New_Year_Charm_-_Owl.jpg?v=1770167816'
  };

  const POPUP_DISMISSED_KEY  = 'bellroy_gift_dismissed_at_qty';
  // ───────────────────────────────────────────────────────────────────────────

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function fetchVariantInfo(variantId) {
    const image = GIFT_IMAGES[variantId] || '';
    try {
      const res = await fetch(`/variants/${variantId}.js`);
      if (res.ok) {
        const variant = await res.json();
        const title = variant.name || variant.title || 'Free Gift';
        return { title, image };
      }
    } catch (e) {
      console.warn('[Bellroy Gift] Could not fetch variant info:', e);
    }
    return { title: 'Free Gift', image };
  }

  /**
   * Add exactly `qtyToAdd` of BOTH charm variants to the cart.
   * qtyToAdd is the *delta* — how many more of each charm to add on top of what's already there.
   */
  async function addGifts(qtyToAdd) {
    for (const variantId of GIFT_VARIANT_IDS) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: qtyToAdd,
          properties: { _bellroy_free_gift: 'true' }
        })
      });
    }
    location.reload();
  }

  /**
   * Returns how many gift charms of each type are already in the cart.
   * Uses the minimum across both variants (so both must be present).
   */
  function giftsAlreadyInCart(cartItems) {
    const counts = GIFT_VARIANT_IDS.map(id => {
      const item = cartItems.find(i => i.variant_id === id);
      return item ? item.quantity : 0;
    });
    return Math.min(...counts);
  }

  /**
   * Tier logic: exactly 1 of each charm per trigger product in cart.
   *   triggerQty === 1 → 1 of each charm expected in cart
   *   triggerQty === 2 → 2 of each charm expected in cart
   *   triggerQty === 3 → 3 of each charm expected in cart
   *   etc.
   */
  function getTargetQtyEach(triggerQty) {
    return triggerQty;
  }

  function wasDismissedForQty(qty) {
    return parseInt(sessionStorage.getItem(POPUP_DISMISSED_KEY) || '0', 10) === qty;
  }

  function dismissPopup(popup, qty) {
    sessionStorage.setItem(POPUP_DISMISSED_KEY, qty);
    if (popup) popup.remove();
  }

  function imgOrPlaceholder(image, title) {
    if (image) return `<img src="${image}" alt="${title}">`;
    return `<div class="bfg-img-placeholder">No image</div>`;
  }

  async function showGiftPopup(qtyToAdd) {
    const dismissedQty = parseInt(sessionStorage.getItem(POPUP_DISMISSED_KEY) || '0', 10);

    if (document.querySelector('#bellroy-free-gift-popup')) return;

    const [gift1, gift2] = await Promise.all(
      GIFT_VARIANT_IDS.map(id => fetchVariantInfo(id))
    );

    const popup = document.createElement("div");
    popup.id = "bellroy-free-gift-popup";
    popup.innerHTML = `
      <div class="bfg-overlay"></div>
      <div class="bfg-modal">
        <button class="bfg-close">&times;</button>
        <h2>Your Free Gifts are Waiting!</h2>
        <p class="bfg-subtitle">
          Eligible with your order - click below to add them to your cart.
        </p>
        <div class="bfg-products">
          <div class="bfg-product">
            ${imgOrPlaceholder(gift1.image, gift1.title)}
            <h4>${gift1.title}</h4>
            <span class="bfg-qty-badge">QTY: 1</span>
          </div>
          <div class="bfg-product">
            ${imgOrPlaceholder(gift2.image, gift2.title)}
            <h4>${gift2.title}</h4>
            <span class="bfg-qty-badge">QTY: 1</span>
          </div>
        </div>
        <div class="bfg-buttons">
          <button class="bfg-add-all">ADD FREE GIFTS</button>
          <button class="bfg-no">NO, THANKS</button>
        </div>
      </div>
    `;

    document.body.appendChild(popup);

    popup.querySelector('.bfg-add-all').onclick = async () => {
      const btn = popup.querySelector('.bfg-add-all');
      btn.textContent = 'Adding...';
      btn.disabled = true;
      await addGifts(qtyToAdd);
    };

    popup.querySelector('.bfg-no').onclick      = () => dismissPopup(popup, _targetQtyEach);
    popup.querySelector('.bfg-close').onclick   = () => dismissPopup(popup, _targetQtyEach);
    popup.querySelector('.bfg-overlay').onclick = () => dismissPopup(popup, _targetQtyEach);
  }

  // Module-level variable to pass targetQtyEach into dismiss handlers cleanly
  let _targetQtyEach = 0;

  async function checkCart() {
    const cart = await getCart();

    // Sum qty of all Bellroy trigger products in cart
    const triggerQty = cart.items
      .filter(i => i.vendor === REQUIRED_VENDOR && TRIGGER_PRODUCT_IDS.includes(i.variant_id))
      .reduce((sum, i) => sum + i.quantity, 0);

    // No trigger products → clear popup and dismissed state, do nothing else
    if (triggerQty === 0) {
      sessionStorage.removeItem(POPUP_DISMISSED_KEY);
      const popup = document.querySelector('#bellroy-free-gift-popup');
      if (popup) popup.remove();
      return;
    }

    const targetQtyEach = getTargetQtyEach(triggerQty);
    _targetQtyEach = targetQtyEach;

    const giftsInCart  = giftsAlreadyInCart(cart.items);
    const currentPopup = document.querySelector('#bellroy-free-gift-popup');

    // If tier changed (e.g. customer added another product), remove stale popup
    // and clear dismissed state so the new tier popup can show
    const dismissedQty = parseInt(sessionStorage.getItem(POPUP_DISMISSED_KEY) || '0', 10);
    if (dismissedQty !== 0 && dismissedQty !== targetQtyEach) {
      sessionStorage.removeItem(POPUP_DISMISSED_KEY);
      if (currentPopup) currentPopup.remove();
    }

    // Gifts already added at correct qty — nothing to do
    if (giftsInCart >= targetQtyEach) return;

    // Don't re-show if already dismissed for this exact tier
    if (wasDismissedForQty(targetQtyEach)) return;

    // The delta: how many more of each charm to add
    const qtyToAdd = targetQtyEach - giftsInCart;

    // Show popup so customer can claim their gifts
    await showGiftPopup(qtyToAdd);
  }

  setInterval(checkCart, 1500);

});